import { render, staticRenderFns } from "./ProgramStudents.vue?vue&type=template&id=38d6f950&scoped=true&"
import script from "./ProgramStudents.vue?vue&type=script&lang=js&"
export * from "./ProgramStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6f950",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d6f950')) {
      api.createRecord('38d6f950', component.options)
    } else {
      api.reload('38d6f950', component.options)
    }
    module.hot.accept("./ProgramStudents.vue?vue&type=template&id=38d6f950&scoped=true&", function () {
      api.rerender('38d6f950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/program/views/ProgramStudents.vue"
export default component.exports